import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams ,useSearchParams} from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { categoryList, detail, list, updateCustomerInfo } from "../../../services/table.services";
import { CASHIER_ORDER_FLOW_TYPES, CUSTOMER_TAGS, LOADER_TIMEOUT_TIME, PHONE_NO_LENGTH, SWAL_SETTINGS } from '../../../../../utils/Constants';
import { TrimText, getColorType, getLocalKey, getTranslatedKey, handleServerValidations } from '../../../../../utils/commonfunction';
import GridLoader from '../../../../restaurant/shared/gridLoader';
import RecordNotFound from '../../../../restaurant/shared/recordNotFound';
import { useFormik } from 'formik';
import CustomError from '../../../../../utils/customError';
import Swal from "sweetalert2";
import * as Yup from 'yup';
import PhoneInput from '../../../../../utils/PhoneInput';
import { Button, Modal } from 'rsuite';
import { transactionDetail } from "../../../services/sales.service";
import GuestCountGate from '../../../../qrOrder/components/GuestCountGate';
import { isGuestGateAsking, selectGuestCountFor, setGuestCount } from '../../../../../redux/slices/guestCount';


export default function CashierCategory() {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const params = useParams();
  const [categoriesList, setCategoriesList] = useState([]);
  const [refreshList, setRefreshList] = useState(false);
  const [loader, setLoader] = useState(true);
  const [tableDetail, setTableDetail] = useState({});
  const [orderDetail, setOrderDetail] = useState({});
  const [combinedOrderItems, setCombinedOrderItems] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [numberOfPersonOptions, setNumberOfPersonOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [langChanged, setLangChanged] = useState(false);

  // WRDS-1202: the guest-count gate, shared with the QR menu. The layout blurs
  // the checkout sidebar off the same predicate — see isGuestGateAsking.
  const answeredGuestCount = useSelector(selectGuestCountFor(params.tableId));
  const guestGateCapacity = Number(tableDetail?.capacity) || 0;
  const guestGateAsking = isGuestGateAsking({
    capacity: guestGateCapacity,
    activeOrder: tableDetail?.activeOrder,
    answered: answeredGuestCount,
  });

  const cashierData = getLocalKey('cashierDetail') ? JSON.parse(getLocalKey('cashierDetail')) : {};
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const orderType = location.state?.type ? location.state?.type : searchParams.get("type");
  const [transactionData, setTransactionData] = useState({});
  const { transactionId } = useParams();

  const getTableDetail = (tableId)=>{
    detail({ o_id: tableId })
    .then((response) => {
      setTableDetail(response?.data);
      let i = 1;
      const numberOfPersonOptionsTemp = [];
      for (i; i <= response?.data?.capacity; i++) {
        numberOfPersonOptionsTemp.push(i);
      }
      setNumberOfPersonOptions(numberOfPersonOptionsTemp);
      const orderData = response?.data?.activeOrder || null;
      setOrderDetail(orderData);

      if (!orderData) {
        setCombinedOrderItems([]);
        setCustomerInfo(null);
        return;
      }

      const combinedOrderedItems = [...(orderData?.ordered_items || [])];
      orderData?.subOrders?.forEach(subOrder => {
        combinedOrderedItems.push(...(subOrder?.ordered_items || []));
      });
      setCombinedOrderItems(combinedOrderedItems);
      let customerDetails = {
        customer_name: orderData?.customer_name || '',
        customer_phone_number: orderData?.customerDetails?.customer_phone_number || '',
        number_of_persons: orderData?.number_of_persons || '',
        customer_tag: orderData?.tag || '',
      }
      setCustomerInfo(customerDetails);
    })
    .catch((err) => {
      console.error(err);
    });
  }

  const getTransactionDetail = (o_id) => {
    transactionDetail({ o_id: o_id })
      .then((response) => {
        setTransactionData(response && response.data ? response.data : []);
        setTableDetail(response && response.data && response?.data?.tableDetail ?response?.data?.tableDetail : null);
        let i = 1;
        const numberOfPersonOptionsTemp = [];
        for (i; i <= response?.data?.capacity; i++) {
          numberOfPersonOptionsTemp.push(i);
        }
        setNumberOfPersonOptions(numberOfPersonOptionsTemp);

        const orderData = response?.data?.orderDetail || null;
        setOrderDetail(orderData);

        if (!orderData) {
          setCombinedOrderItems([]);
          setCustomerInfo(null);
          return;
        }

        const combinedOrderedItems = [...(orderData?.ordered_items || [])];
        orderData?.subOrders?.forEach(subOrder => {
          combinedOrderedItems.push(...(subOrder?.ordered_items || []));
        });
        setCombinedOrderItems(combinedOrderedItems);
        let customerDetails = {
          customer_name: orderData?.customer_name || '',
          customer_phone_number: orderData?.customerDetails?.customer_phone_number || '',
          number_of_persons: orderData?.number_of_persons || '',
          customer_tag: orderData?.tag || '',
        }
        setCustomerInfo(customerDetails);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  };

  useEffect(() => {
    if (!params.tableId) {
      navigate('/cashier/dashboard');
      return;
    }

    if (orderType === CASHIER_ORDER_FLOW_TYPES.EDIT_SALES) {
      getTransactionDetail(params.tableId);
      return;
    }

    if (
      orderType === CASHIER_ORDER_FLOW_TYPES.NEW_ORDER ||
      orderType === CASHIER_ORDER_FLOW_TYPES.EDIT_ORDER ||
      orderType === CASHIER_ORDER_FLOW_TYPES.SPLIT_PAY
    ) {
      getTableDetail(params.tableId);
    }
  }, [params.tableId, isEditing, langChanged, orderType]);


  useEffect(() => {
    setLoader(true);
    categoryList()
      .then((data) => {
        if (data && data.data) {
          setCategoriesList(data.data.list || []);
        } else {
          setCategoriesList([]);
        }

        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        console.error("error ====> ", error);
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      });
  }, [refreshList , langChanged]);

  const handleCategoryClick = (categoryId) => {

  
    if (orderType === CASHIER_ORDER_FLOW_TYPES.NEW_ORDER) {
      navigate(
        `/cashier/dashboard/menu/${params.tableId}/${categoryId}`,
        { state: { type: CASHIER_ORDER_FLOW_TYPES.NEW_ORDER } }
      );
    }
    else if (orderType === CASHIER_ORDER_FLOW_TYPES.EDIT_SALES) {
      navigate(
        `/cashier/dashboard/menu/${params.tableId}/${categoryId}?type=${orderType}`,
        { state: { type: CASHIER_ORDER_FLOW_TYPES.EDIT_SALES } }
      );
    }
    else {
      const nextOrderType = orderType === CASHIER_ORDER_FLOW_TYPES.SPLIT_PAY
        ? CASHIER_ORDER_FLOW_TYPES.SPLIT_PAY
        : CASHIER_ORDER_FLOW_TYPES.EDIT_ORDER;

      navigate(`/cashier/dashboard/menu/${params.tableId}/${categoryId}?type=${nextOrderType}` ,
      { state: { type: nextOrderType } });
    }
  };
  
  const isCategorySelected = (categoryId) => {
    const exists = combinedOrderItems.some(item => item.category_id === categoryId);
    return exists
  };

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const getLabelByValue = (value) => {
    const item = CUSTOMER_TAGS.find(shapeType => shapeType.value === value);
    return item ? item.label : '';
  };

  const customerForm = useFormik({
    initialValues: {
      order_id: orderDetail?._id,
      cashier_id: cashierData?._id,
      customer_name: orderDetail?.customer_name || '',
      customer_phone_number: orderDetail?.customerDetails?.customer_phone_number || '',
      number_of_persons: orderDetail?.number_of_persons || '',
      tag: orderDetail?.tag || CUSTOMER_TAGS.REGULAR,
      customer_note: orderDetail?.customer_note || '',
    },
    validationSchema: Yup.object({
      // name and phone are optional; validate format only when a value is entered.
      customer_name: Yup.string().trim().max(100, "max_length_error"),
      number_of_persons: Yup.string().trim().required("err_no_of_person"),
      customer_phone_number: Yup.string()
        .test('phone_digit_error', 'label_phone_number_digits_error', (value) => {
          const phoneNumber = value ? (value.split(" "))[1] : null;
          return !phoneNumber || /^\d+$/.test(phoneNumber);
        }
        )
        .test('phone_min_length', 'label_phone_number_min_length_error', (value) => {
          const phoneNumber = value ? (value.split(" "))[1] : null;
          return !phoneNumber || phoneNumber.length >= PHONE_NO_LENGTH.min;
        }
        )
        .test('phone_max_length', 'label_phone_number_max_length_error', (value) => {
          const phoneNumber = value ? (value.split(" "))[1] : null;
          return !phoneNumber || phoneNumber.length <= PHONE_NO_LENGTH.max;
        }
        ),
    }),
    enableReinitialize: true,
    onSubmit: (values, { resetForm, setFieldValue }) => {
      updateCustomerInfo(values)
        .then((response) => {
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            setIsEditing(false)
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          console.error("Error updating profile", error);
        });
    },
  });

  useEffect(() => {
    const handleLanguageChange = () => {
      setLangChanged((current) => !current);
    };

    document.addEventListener('language_change', handleLanguageChange);

    return () => {
      document.removeEventListener('language_change', handleLanguageChange);
    };
  }, []);

  return (
    <div className='dashboard-cashier-left d-flex flex-column'>
      <div className='cashier-head text-center'>
        <div className='btns-head-in-left gap-2 d-flex'>
          <button className='btn btn-icon' onClick={() => {  navigate('.', { replace: true, state: null }); // clear current state
            navigate(-1);    }}>
            <i className='ti ti-arrow-left'></i>
          </button>
        </div>
        <h4>{TrimText(tableDetail?.table_number, 20)}</h4>
        <div className='btns-head-in gap-2 d-flex'>
          <button className='btn btn-icon' onClick={() => setIsOpen(true)}>
            <i className='ti ti-user'></i>
          </button>
          {/* <button className='btn btn-icon' data-bs-toggle="modal" data-bs-target="#exampleModal">
            <i className='ti ti-user'></i>
          </button> */}
          <button className='btn btn-icon'>
            <i className='ti ti-printer'></i>
          </button>
        </div>
      </div>


      {/* WRDS-1202: the gate blurs the categories until the guest count is
          answered. It deliberately starts BELOW cashier-head so the back
          button stays live — backing out is how a cashier abandons the
          count, and a blurred header would trap them here. */}
      <GuestCountGate
        asking={guestGateAsking}
        capacity={guestGateCapacity}
        onConfirm={(count) => dispatch(setGuestCount({ tableId: params.tableId, count }))}
      >
      <div className='cashier-category-wrap'>
        {
          loader ?
            <GridLoader />
            :
            <>
              {categoriesList.length ?
                <div className='category-list-grid'>
                  {categoriesList.map((item, index) => {
                    return (
                      <div key={index} style={{ background: item?.color }}
                        className={`category-box cp ${`category_bg_${getColorType(item?.color)}`} ${isCategorySelected(item?._id) ? 'item-selected' : ''}`}
                        onClick={() => handleCategoryClick(item?._id)}
                      >
                        <div className="category-name">
                          <span>{getTranslatedKey('name',item)}</span> 
                          {/* {item?.name} */}
                        </div>
                        <div className="category-item-info">
                          <a className="text-white" href="#">{item?.items_count} {t('label_items')}</a>
                        </div>
                      </div>)
                  })}

                </div>
                :
                <RecordNotFound heading="no_category_found_text" />
              }
            </>
        }
      </div>
      </GuestCountGate>
      
      <Modal backdrop="static" open={isOpen} className='modal-cashier'>
        <Modal.Header className="modal-header d-flex justify-content-between">
        <button type="button" className="btn btn-icon" onClick={() => setIsOpen(false)} aria-label="Close">
            <i className="ti ti-arrow-left"></i>
          </button>
          <h1 className="modal-title fs-5">{t('label_customer_info')}</h1>
          <button type="button" className="btn btn-icon" onClick={() => setIsOpen(false)} aria-label="Close">
            <i className="ti ti-x"></i> {/* Replace this with your custom icon if needed */}
          </button>
        </Modal.Header>
        <hr className='mb-0' />
        <Modal.Body className="modal-body mt-0">
          {!isEditing ? (
            <>
              <div className='card-list'>
                <ul>
                  <li>
                    <h4>{t('list_heading_name')}</h4>
                    <h3>{TrimText(customerInfo?.customer_name)}</h3>
                  </li>
                  <li>
                    <h4>{t('label_phone_number')}</h4>
                    <h3>{customerInfo?.customer_phone_number}</h3>
                  </li>
                  <li>
                    <h4>{t('number_of_person_text')}</h4>
                    <h3>{customerInfo?.number_of_persons}</h3>
                  </li>
                  <li>
                    <h4>{t('label_tag')}</h4>
                    <h3>{customerInfo?.customer_tag ? customerInfo?.customer_tag===CUSTOMER_TAGS.VIP ? t('tag_vip'): t('tag_regular'): ""}</h3>
                  </li>
                  <li>
                    <h4>{t('label_special_requirement')}</h4>
                    <h3>{customerInfo?.customer_note}</h3>
                  </li>
                </ul>
              </div>
              <Button onClick={toggleEdit} className='btn btn-primary w-100 mt-3'>
                {t('btn_edit')}
              </Button>
            </>
          ) : (
            <form onSubmit={customerForm.handleSubmit}>
              <div className='mb-3'>
                <label className='form-label'>{t('list_heading_name')}</label>
                <input
                  type='text'
                  className='form-control'
                  placeholder={t('placeholder_enter_addon_option_name')}
                  name="customer_name"
                  value={customerForm.values.customer_name}
                  onChange={customerForm.handleChange}
                />
                <CustomError name="customer_name" form={customerForm} className="text-danger" />
              </div>

              <div className='mb-3'>
                <label className='form-label'>{t('label_phone_number')}</label>
                <PhoneInput
                  placeholder={t('placeholder_phone_number')}
                  value={customerForm.values.customer_phone_number}
                  onChange={(e) => customerForm.setFieldValue('customer_phone_number', e?.phone_number)}
                  onBlur={customerForm.handleBlur}
                />
                <CustomError name="customer_phone_number" form={customerForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
              </div>

              <div className='mb-3'>
                <label className='form-label'>{t('number_of_person_text')}<span>*</span></label>
                <select
                  className='form-control cp'
                  name='number_of_persons'
                  value={customerForm.values.number_of_persons}
                  onChange={(e) => customerForm.setFieldValue("number_of_persons", e.target.value ? Number(e.target.value) : "")}
                >
                  <option value="">{t('input_select_text')}</option>
                  {numberOfPersonOptions.map((option, index) => (
                    <option value={option} key={index}>{option}</option>
                  ))}
                </select>
                <CustomError className="text-danger" name="number_of_persons" form={customerForm} />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_customer_tag")}</label>
                <select
                  className="form-control cp"
                  name="tag"
                  value={customerForm.values.tag}
                  onChange={customerForm.handleChange}
                  onBlur={customerForm.handleBlur}
                >
                  <option value="" label={t("placeholder_select_table_customer_tag")} />
                  <option value={CUSTOMER_TAGS.VIP}>{CUSTOMER_TAGS.VIP}</option>
                  <option value={CUSTOMER_TAGS.REGULAR}>{CUSTOMER_TAGS.REGULAR}</option>
                </select>
                <CustomError className="text-danger" name="tag" form={customerForm} />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_special_requirement")}</label>
                <textarea
                  className="form-control"
                  rows={3}
                  maxLength={200}
                  placeholder={t("placeholder_special_requirement")}
                  name="customer_note"
                  value={customerForm.values.customer_note}
                  onChange={customerForm.handleChange}
                />
              </div>
              <Button type="submit" className="btn btn-primary w-100 mt-3" block>
                {t('btn_save')}
              </Button>
            </form>
          )}
        </Modal.Body>
      </Modal>


    </div>
  )
}
